import { render, staticRenderFns } from "./analyticsBreakdownTable.vue?vue&type=template&id=289813ea&scoped=true&"
import script from "./analyticsBreakdownTable.vue?vue&type=script&lang=js&"
export * from "./analyticsBreakdownTable.vue?vue&type=script&lang=js&"
import style0 from "./analyticsBreakdownTable.vue?vue&type=style&index=0&id=289813ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289813ea",
  null
  
)

export default component.exports